import * as preact from "preact";

import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import stores from "stores/stores";
import PracticeButton from "views/PracticeButton";

interface State {
  /** By learning language: whether there are previous conversations */
  hasHistory: Record<string, boolean>;
}

/**
 * Chat on the Practice page: a button starting a conversation, beside what
 * it is and, once there are some, a link to previous ones.
 */
export default class ChatPracticeView extends preact.Component<{}, State> {
  state: State = { hasHistory: {} };
  private requestedLanguages = new Set<string>();

  componentDidMount() {
    void this.fetchHasHistory();
  }

  componentDidUpdate() {
    void this.fetchHasHistory();
  }

  async fetchHasHistory() {
    const language = stores.user.currentLearningLanguage.value;
    if (
      !stores.user.hasChatFeature.value ||
      this.requestedLanguages.has(language)
    ) {
      return;
    }
    this.requestedLanguages.add(language);
    const { hasHistory } = (
      await readlangClient.request(
        "GET",
        `/api/chat/hasHistory/${language}`,
        {}
      )
    ).data;
    this.setState((state) => ({
      hasHistory: { ...state.hasHistory, [language]: hasHistory },
    }));
  }

  render() {
    const language = stores.user.currentLearningLanguage.value;
    if (
      stores.user.isLocalMode.value ||
      !languageMap.languageSupportsChat(language)
    ) {
      return null;
    }
    return (
      <div class="chatPractice">
        <PracticeButton
          // Without Premium, the chat list explains conversations and upsells
          href={stores.user.hasChatFeature.value ? "/chat/start" : "/chat"}
          icon="/content/chat-v3.svg"
          title="Start a conversation"
        />
        <div>
          <p>
            Make friends with Ami, a chatbot who will help you practice your
            conversational {languageMap.map[language].english}.
          </p>
          {this.state.hasHistory[language] ? (
            <p class="moreLink">
              <a href="/chat">Previous conversations</a>
            </p>
          ) : null}
        </div>
      </div>
    );
  }
}
